// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ActionBank, ActionBankT, verifyActionBank } from "./action-bank";
import { ActionCatalog, ActionCatalogT, verifyActionCatalog } from "./action-catalog";
import {
  ActionCatalogAdapter,
  ActionCatalogAdapterT,
  verifyActionCatalogAdapter,
} from "./action-catalog-adapter";
import { Adapter, AdapterT, verifyAdapter } from "./adapter";
import { BacnetPoint, BacnetPointT, verifyBacnetPoint } from "./bacnet-point";
import { Bank, BankT, verifyBank } from "./bank";
import { BankFloor, BankFloorT, verifyBankFloor } from "./bank-floor";
import { Channel, ChannelT, verifyChannel } from "./channel";
import { ChannelModifier, ChannelModifierT, verifyChannelModifier } from "./channel-modifier";
import { ContactInfo, ContactInfoT, verifyContactInfo } from "./contact-info";
import { ControlRoute, ControlRouteT, verifyControlRoute } from "./control-route";
import {
  ControlRouteTarget,
  ControlRouteTargetT,
  verifyControlRouteTarget,
} from "./control-route-target";
import { CustomKey, CustomKeyT, verifyCustomKey } from "./custom-key";
import { DebounceOverride, DebounceOverrideT, verifyDebounceOverride } from "./debounce-override";
import { ExportMeta, ExportMetaT, verifyExportMeta } from "./export-meta";
import { Holiday, HolidayT, verifyHoliday } from "./holiday";
import { Key, KeyT, verifyKey } from "./key";
import { LeadingZeroes, LeadingZeroesT, verifyLeadingZeroes } from "./leading-zeroes";
import { Lift, LiftT, verifyLift } from "./lift";
import { LiftFloor, LiftFloorT, verifyLiftFloor } from "./lift-floor";
import { Message, MessageT, verifyMessage } from "./message";
import { MessageType, MessageTypeT, verifyMessageType } from "./message-type";
import { MonitorGrid, MonitorGridT, verifyMonitorGrid } from "./monitor-grid";
import { Notification, NotificationT, verifyNotification } from "./notification";
import { NotificationBank, NotificationBankT, verifyNotificationBank } from "./notification-bank";
import { NotificationUser, NotificationUserT, verifyNotificationUser } from "./notification-user";
import { Organization, OrganizationT, verifyOrganization } from "./organization";
import { Parameter, ParameterT, verifyParameter } from "./parameter";
import { Role, RoleT, verifyRole } from "./role";
import {
  RoleBankPermission,
  RoleBankPermissionT,
  verifyRoleBankPermission,
} from "./role-bank-permission";
import {
  RoleFloorPermission,
  RoleFloorPermissionT,
  verifyRoleFloorPermission,
} from "./role-floor-permission";
import {
  RoleLiftPermission,
  RoleLiftPermissionT,
  verifyRoleLiftPermission,
} from "./role-lift-permission";
import { RoleOrgGrant, RoleOrgGrantT, verifyRoleOrgGrant } from "./role-org-grant";
import { Server, ServerT, verifyServer } from "./server";
import { TimedAction, TimedActionT, verifyTimedAction } from "./timed-action";
import { User, UserT, verifyUser } from "./user";
import { WizardDraft, WizardDraftT, verifyWizardDraft } from "./wizard-draft";

/**
 * Complete organization export containing all entity data.
 *
 * Field ordering follows the wizard stage dependency order:
 * Organization → Server → Adapter → Channel → Bank →
 * ChannelModifier → Lift → `BACnet` → User/Role →
 * Notification → Action → Monitor
 */
export class OrgExport implements flatbuffers.IUnpackableObject<OrgExportT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): OrgExport {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsOrgExport(bb: flatbuffers.ByteBuffer, obj?: OrgExport): OrgExport {
    return (obj || new OrgExport()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsOrgExport(bb: flatbuffers.ByteBuffer, obj?: OrgExport): OrgExport {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new OrgExport()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  meta(obj?: ExportMeta): ExportMeta | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new ExportMeta()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Stage 1: Organization hierarchy
   */
  organizations(index: number, obj?: Organization): Organization | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Organization()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  organizationsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  parameters(index: number, obj?: Parameter): Parameter | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new Parameter()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  parametersLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  holidays(index: number, obj?: Holiday): Holiday | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? (obj || new Holiday()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  holidaysLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Stage 2: Edge servers
   */
  servers(index: number, obj?: Server): Server | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset
      ? (obj || new Server()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  serversLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Stage 3: Protocol adapters and message keys
   */
  leadingZeroes(index: number, obj?: LeadingZeroes): LeadingZeroes | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset
      ? (obj || new LeadingZeroes()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  leadingZeroesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  adapters(index: number, obj?: Adapter): Adapter | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset
      ? (obj || new Adapter()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  adaptersLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  keys(index: number, obj?: Key): Key | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset
      ? (obj || new Key()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  keysLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  customKeys(index: number, obj?: CustomKey): CustomKey | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset
      ? (obj || new CustomKey()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  customKeysLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Stage 4: Communication channels
   */
  channels(index: number, obj?: Channel): Channel | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset
      ? (obj || new Channel()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  channelsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Stage 5: Elevator/escalator banks and floor configs
   */
  banks(index: number, obj?: Bank): Bank | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset
      ? (obj || new Bank()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  banksLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  bankFloors(index: number, obj?: BankFloor): BankFloor | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset
      ? (obj || new BankFloor()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  bankFloorsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Stage 6: Channel modifiers — message rewriting / forwarding rules
   * that bridge two channels' adapter mappings. Depends on Banks
   * because each channel's adapter linkage is established there.
   */
  channelModifiers(index: number, obj?: ChannelModifier): ChannelModifier | null {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset
      ? (obj || new ChannelModifier()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  channelModifiersLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Stage 7: Individual cars/units and their floor mappings
   */
  lifts(index: number, obj?: Lift): Lift | null {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset
      ? (obj || new Lift()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  liftsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  liftFloors(index: number, obj?: LiftFloor): LiftFloor | null {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset
      ? (obj || new LiftFloor()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  liftFloorsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Stage 8: `BACnet`-specific point descriptions
   */
  bacnetPoints(index: number, obj?: BacnetPoint): BacnetPoint | null {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset
      ? (obj || new BacnetPoint()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  bacnetPointsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Stage 9: Access control — roles, users, contact info
   */
  roles(index: number, obj?: Role): Role | null {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset
      ? (obj || new Role()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  rolesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  users(index: number, obj?: User): User | null {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset
      ? (obj || new User()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  usersLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  contactInfos(index: number, obj?: ContactInfo): ContactInfo | null {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset
      ? (obj || new ContactInfo()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  contactInfosLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Stage 10: Alert rules and delivery configuration
   */
  notifications(index: number, obj?: Notification): Notification | null {
    const offset = this.bb!.__offset(this.bb_pos, 42);
    return offset
      ? (obj || new Notification()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  notificationsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 42);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  notificationUsers(index: number, obj?: NotificationUser): NotificationUser | null {
    const offset = this.bb!.__offset(this.bb_pos, 44);
    return offset
      ? (obj || new NotificationUser()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  notificationUsersLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 44);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  debounceOverrides(index: number, obj?: DebounceOverride): DebounceOverride | null {
    const offset = this.bb!.__offset(this.bb_pos, 46);
    return offset
      ? (obj || new DebounceOverride()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  debounceOverridesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 46);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Stage 11: Control commands and button configurations
   */
  actionCatalogs(index: number, obj?: ActionCatalog): ActionCatalog | null {
    const offset = this.bb!.__offset(this.bb_pos, 48);
    return offset
      ? (obj || new ActionCatalog()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  actionCatalogsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 48);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  actionCatalogAdapters(index: number, obj?: ActionCatalogAdapter): ActionCatalogAdapter | null {
    const offset = this.bb!.__offset(this.bb_pos, 50);
    return offset
      ? (obj || new ActionCatalogAdapter()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  actionCatalogAdaptersLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 50);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  actionBanks(index: number, obj?: ActionBank): ActionBank | null {
    const offset = this.bb!.__offset(this.bb_pos, 52);
    return offset
      ? (obj || new ActionBank()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  actionBanksLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 52);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Stage 12: Dashboard layouts
   */
  monitorGrids(index: number, obj?: MonitorGrid): MonitorGrid | null {
    const offset = this.bb!.__offset(this.bb_pos, 54);
    return offset
      ? (obj || new MonitorGrid()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  monitorGridsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 54);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Stage 9 (cont.): Per-role scope grants. Appended at the END of the
   * table (not inline beside `roles`) so the new fields obey `FlatBuffer`'s
   * new-fields-at-end wire-compat rule for any previously serialized .lnx
   * export. Empty vectors = the role has access to all scopes of that
   * class (default enforced by consumers, not the schema).
   */
  roleBankPermissions(index: number, obj?: RoleBankPermission): RoleBankPermission | null {
    const offset = this.bb!.__offset(this.bb_pos, 56);
    return offset
      ? (obj || new RoleBankPermission()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  roleBankPermissionsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 56);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  roleLiftPermissions(index: number, obj?: RoleLiftPermission): RoleLiftPermission | null {
    const offset = this.bb!.__offset(this.bb_pos, 58);
    return offset
      ? (obj || new RoleLiftPermission()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  roleLiftPermissionsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 58);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  roleFloorPermissions(index: number, obj?: RoleFloorPermission): RoleFloorPermission | null {
    const offset = this.bb!.__offset(this.bb_pos, 60);
    return offset
      ? (obj || new RoleFloorPermission()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  roleFloorPermissionsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 60);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Stage 13: Timed actions — scheduled Control commands per bank (start/stop
   * at a time, recurring daily or one-shot). Appended at the END of the table
   * (not renumbering any existing stage) so previously serialized .lnx exports
   * stay wire-compatible. Empty vector = the org has no timed actions.
   */
  timedActions(index: number, obj?: TimedAction): TimedAction | null {
    const offset = this.bb!.__offset(this.bb_pos, 62);
    return offset
      ? (obj || new TimedAction()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  timedActionsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 62);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Stage 11 (cont.): Messages backing action_catalogs.message_id and
   * `action_banks`.message_id/toggle_message_id, and message_types backing
   * messages.message_type_id. Without them a re-imported `action_catalog` or
   * `action_bank` references a `messages` row the export never captured, and
   * the import hits a FK violation. Appended at the END of the table (not
   * renumbering any existing stage) so previously serialized .lnx exports
   * stay wire-compatible.
   */
  messages(index: number, obj?: Message): Message | null {
    const offset = this.bb!.__offset(this.bb_pos, 64);
    return offset
      ? (obj || new Message()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  messagesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 64);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  messageTypes(index: number, obj?: MessageType): MessageType | null {
    const offset = this.bb!.__offset(this.bb_pos, 66);
    return offset
      ? (obj || new MessageType()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  messageTypesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 66);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Cross-org reachability grants for this org's roles (role_org_grants).
   * Appended at the END of the table so previously serialized .lnx exports
   * stay wire-compatible.
   *
   * Unlike the scope-grant vectors above, an EMPTY vector here does not mean
   * "all orgs" — it means the roles reach only their own subtree. Dropping
   * these rows therefore fails CLOSED, which is the correct direction for a
   * permission the exporter might not carry.
   */
  roleOrgGrants(index: number, obj?: RoleOrgGrant): RoleOrgGrant | null {
    const offset = this.bb!.__offset(this.bb_pos, 68);
    return offset
      ? (obj || new RoleOrgGrant()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  roleOrgGrantsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 68);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Stage 4 (cont.): Control-write routing rules for merged channels, and
   * their endpoint targets. Belongs with Stage 4 (Channels) conceptually
   * because each rule is channel-scoped, but appended at the END of the
   * table so no existing stage renumbers and previously serialized .lnx
   * exports stay wire-compatible. Targets are exported as their own vector
   * rather than only nested under `control_routes` so an importer can
   * resolve them in one pass. Empty vectors = no channel in the org uses
   * per-control write routing.
   */
  controlRoutes(index: number, obj?: ControlRoute): ControlRoute | null {
    const offset = this.bb!.__offset(this.bb_pos, 70);
    return offset
      ? (obj || new ControlRoute()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  controlRoutesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 70);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  controlRouteTargets(index: number, obj?: ControlRouteTarget): ControlRouteTarget | null {
    const offset = this.bb!.__offset(this.bb_pos, 72);
    return offset
      ? (obj || new ControlRouteTarget()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  controlRouteTargetsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 72);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Stage 10 (cont.): which banks each notification covers. Belongs with
   * Stage 10 (Notifications) conceptually, but appended at the END of the
   * table so no existing stage renumbers and previously serialized .lnx
   * exports stay wire-compatible.
   *
   * An EMPTY vector does not mean "no banks" for a legacy export — a
   * notification written before this vector existed covers the single bank
   * in its own `bank_id`, and the importer backfills one join row from it.
   */
  notificationBanks(index: number, obj?: NotificationBank): NotificationBank | null {
    const offset = this.bb!.__offset(this.bb_pos, 74);
    return offset
      ? (obj || new NotificationBank()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  notificationBanksLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 74);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * The setup wizard's unsaved step state for this organization and its
   * servers and banks (`wizard_drafts`). Not a wizard stage of its own: each
   * draft belongs to the step in its `step_index`. Appended at the END of the
   * table so previously serialized .lnx exports stay wire-compatible. An
   * empty vector means the organization had no draft in progress.
   */
  wizardDrafts(index: number, obj?: WizardDraft): WizardDraft | null {
    const offset = this.bb!.__offset(this.bb_pos, 76);
    return offset
      ? (obj || new WizardDraft()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  wizardDraftsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 76);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startOrgExport(builder: flatbuffers.Builder) {
    builder.startObject(37);
  }

  static addMeta(builder: flatbuffers.Builder, metaOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, metaOffset, 0);
  }

  static addOrganizations(builder: flatbuffers.Builder, organizationsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, organizationsOffset, 0);
  }

  static createOrganizationsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startOrganizationsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addParameters(builder: flatbuffers.Builder, parametersOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, parametersOffset, 0);
  }

  static createParametersVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startParametersVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addHolidays(builder: flatbuffers.Builder, holidaysOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, holidaysOffset, 0);
  }

  static createHolidaysVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startHolidaysVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addServers(builder: flatbuffers.Builder, serversOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, serversOffset, 0);
  }

  static createServersVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startServersVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addLeadingZeroes(builder: flatbuffers.Builder, leadingZeroesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, leadingZeroesOffset, 0);
  }

  static createLeadingZeroesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startLeadingZeroesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addAdapters(builder: flatbuffers.Builder, adaptersOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, adaptersOffset, 0);
  }

  static createAdaptersVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startAdaptersVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addKeys(builder: flatbuffers.Builder, keysOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, keysOffset, 0);
  }

  static createKeysVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startKeysVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addCustomKeys(builder: flatbuffers.Builder, customKeysOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, customKeysOffset, 0);
  }

  static createCustomKeysVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startCustomKeysVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addChannels(builder: flatbuffers.Builder, channelsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, channelsOffset, 0);
  }

  static createChannelsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startChannelsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addBanks(builder: flatbuffers.Builder, banksOffset: flatbuffers.Offset) {
    builder.addFieldOffset(10, banksOffset, 0);
  }

  static createBanksVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startBanksVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addBankFloors(builder: flatbuffers.Builder, bankFloorsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(11, bankFloorsOffset, 0);
  }

  static createBankFloorsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startBankFloorsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addChannelModifiers(
    builder: flatbuffers.Builder,
    channelModifiersOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(12, channelModifiersOffset, 0);
  }

  static createChannelModifiersVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startChannelModifiersVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addLifts(builder: flatbuffers.Builder, liftsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(13, liftsOffset, 0);
  }

  static createLiftsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startLiftsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addLiftFloors(builder: flatbuffers.Builder, liftFloorsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(14, liftFloorsOffset, 0);
  }

  static createLiftFloorsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startLiftFloorsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addBacnetPoints(builder: flatbuffers.Builder, bacnetPointsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(15, bacnetPointsOffset, 0);
  }

  static createBacnetPointsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startBacnetPointsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addRoles(builder: flatbuffers.Builder, rolesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(16, rolesOffset, 0);
  }

  static createRolesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startRolesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addUsers(builder: flatbuffers.Builder, usersOffset: flatbuffers.Offset) {
    builder.addFieldOffset(17, usersOffset, 0);
  }

  static createUsersVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startUsersVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addContactInfos(builder: flatbuffers.Builder, contactInfosOffset: flatbuffers.Offset) {
    builder.addFieldOffset(18, contactInfosOffset, 0);
  }

  static createContactInfosVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startContactInfosVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addNotifications(builder: flatbuffers.Builder, notificationsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(19, notificationsOffset, 0);
  }

  static createNotificationsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startNotificationsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addNotificationUsers(
    builder: flatbuffers.Builder,
    notificationUsersOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(20, notificationUsersOffset, 0);
  }

  static createNotificationUsersVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startNotificationUsersVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addDebounceOverrides(
    builder: flatbuffers.Builder,
    debounceOverridesOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(21, debounceOverridesOffset, 0);
  }

  static createDebounceOverridesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startDebounceOverridesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addActionCatalogs(builder: flatbuffers.Builder, actionCatalogsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(22, actionCatalogsOffset, 0);
  }

  static createActionCatalogsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startActionCatalogsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addActionCatalogAdapters(
    builder: flatbuffers.Builder,
    actionCatalogAdaptersOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(23, actionCatalogAdaptersOffset, 0);
  }

  static createActionCatalogAdaptersVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startActionCatalogAdaptersVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addActionBanks(builder: flatbuffers.Builder, actionBanksOffset: flatbuffers.Offset) {
    builder.addFieldOffset(24, actionBanksOffset, 0);
  }

  static createActionBanksVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startActionBanksVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addMonitorGrids(builder: flatbuffers.Builder, monitorGridsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(25, monitorGridsOffset, 0);
  }

  static createMonitorGridsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startMonitorGridsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addRoleBankPermissions(
    builder: flatbuffers.Builder,
    roleBankPermissionsOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(26, roleBankPermissionsOffset, 0);
  }

  static createRoleBankPermissionsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startRoleBankPermissionsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addRoleLiftPermissions(
    builder: flatbuffers.Builder,
    roleLiftPermissionsOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(27, roleLiftPermissionsOffset, 0);
  }

  static createRoleLiftPermissionsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startRoleLiftPermissionsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addRoleFloorPermissions(
    builder: flatbuffers.Builder,
    roleFloorPermissionsOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(28, roleFloorPermissionsOffset, 0);
  }

  static createRoleFloorPermissionsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startRoleFloorPermissionsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addTimedActions(builder: flatbuffers.Builder, timedActionsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(29, timedActionsOffset, 0);
  }

  static createTimedActionsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startTimedActionsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addMessages(builder: flatbuffers.Builder, messagesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(30, messagesOffset, 0);
  }

  static createMessagesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startMessagesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addMessageTypes(builder: flatbuffers.Builder, messageTypesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(31, messageTypesOffset, 0);
  }

  static createMessageTypesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startMessageTypesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addRoleOrgGrants(builder: flatbuffers.Builder, roleOrgGrantsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(32, roleOrgGrantsOffset, 0);
  }

  static createRoleOrgGrantsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startRoleOrgGrantsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addControlRoutes(builder: flatbuffers.Builder, controlRoutesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(33, controlRoutesOffset, 0);
  }

  static createControlRoutesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startControlRoutesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addControlRouteTargets(
    builder: flatbuffers.Builder,
    controlRouteTargetsOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(34, controlRouteTargetsOffset, 0);
  }

  static createControlRouteTargetsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startControlRouteTargetsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addNotificationBanks(
    builder: flatbuffers.Builder,
    notificationBanksOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(35, notificationBanksOffset, 0);
  }

  static createNotificationBanksVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startNotificationBanksVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addWizardDrafts(builder: flatbuffers.Builder, wizardDraftsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(36, wizardDraftsOffset, 0);
  }

  static createWizardDraftsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startWizardDraftsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endOrgExport(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // meta
    return offset;
  }

  static finishOrgExportBuffer(builder: flatbuffers.Builder, offset: flatbuffers.Offset) {
    builder.finish(offset);
  }

  static finishSizePrefixedOrgExportBuffer(
    builder: flatbuffers.Builder,
    offset: flatbuffers.Offset,
  ) {
    builder.finish(offset, undefined, true);
  }

  static createOrgExport(
    builder: flatbuffers.Builder,
    metaOffset: flatbuffers.Offset,
    organizationsOffset: flatbuffers.Offset,
    parametersOffset: flatbuffers.Offset,
    holidaysOffset: flatbuffers.Offset,
    serversOffset: flatbuffers.Offset,
    leadingZeroesOffset: flatbuffers.Offset,
    adaptersOffset: flatbuffers.Offset,
    keysOffset: flatbuffers.Offset,
    customKeysOffset: flatbuffers.Offset,
    channelsOffset: flatbuffers.Offset,
    banksOffset: flatbuffers.Offset,
    bankFloorsOffset: flatbuffers.Offset,
    channelModifiersOffset: flatbuffers.Offset,
    liftsOffset: flatbuffers.Offset,
    liftFloorsOffset: flatbuffers.Offset,
    bacnetPointsOffset: flatbuffers.Offset,
    rolesOffset: flatbuffers.Offset,
    usersOffset: flatbuffers.Offset,
    contactInfosOffset: flatbuffers.Offset,
    notificationsOffset: flatbuffers.Offset,
    notificationUsersOffset: flatbuffers.Offset,
    debounceOverridesOffset: flatbuffers.Offset,
    actionCatalogsOffset: flatbuffers.Offset,
    actionCatalogAdaptersOffset: flatbuffers.Offset,
    actionBanksOffset: flatbuffers.Offset,
    monitorGridsOffset: flatbuffers.Offset,
    roleBankPermissionsOffset: flatbuffers.Offset,
    roleLiftPermissionsOffset: flatbuffers.Offset,
    roleFloorPermissionsOffset: flatbuffers.Offset,
    timedActionsOffset: flatbuffers.Offset,
    messagesOffset: flatbuffers.Offset,
    messageTypesOffset: flatbuffers.Offset,
    roleOrgGrantsOffset: flatbuffers.Offset,
    controlRoutesOffset: flatbuffers.Offset,
    controlRouteTargetsOffset: flatbuffers.Offset,
    notificationBanksOffset: flatbuffers.Offset,
    wizardDraftsOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    OrgExport.startOrgExport(builder);
    OrgExport.addMeta(builder, metaOffset);
    OrgExport.addOrganizations(builder, organizationsOffset);
    OrgExport.addParameters(builder, parametersOffset);
    OrgExport.addHolidays(builder, holidaysOffset);
    OrgExport.addServers(builder, serversOffset);
    OrgExport.addLeadingZeroes(builder, leadingZeroesOffset);
    OrgExport.addAdapters(builder, adaptersOffset);
    OrgExport.addKeys(builder, keysOffset);
    OrgExport.addCustomKeys(builder, customKeysOffset);
    OrgExport.addChannels(builder, channelsOffset);
    OrgExport.addBanks(builder, banksOffset);
    OrgExport.addBankFloors(builder, bankFloorsOffset);
    OrgExport.addChannelModifiers(builder, channelModifiersOffset);
    OrgExport.addLifts(builder, liftsOffset);
    OrgExport.addLiftFloors(builder, liftFloorsOffset);
    OrgExport.addBacnetPoints(builder, bacnetPointsOffset);
    OrgExport.addRoles(builder, rolesOffset);
    OrgExport.addUsers(builder, usersOffset);
    OrgExport.addContactInfos(builder, contactInfosOffset);
    OrgExport.addNotifications(builder, notificationsOffset);
    OrgExport.addNotificationUsers(builder, notificationUsersOffset);
    OrgExport.addDebounceOverrides(builder, debounceOverridesOffset);
    OrgExport.addActionCatalogs(builder, actionCatalogsOffset);
    OrgExport.addActionCatalogAdapters(builder, actionCatalogAdaptersOffset);
    OrgExport.addActionBanks(builder, actionBanksOffset);
    OrgExport.addMonitorGrids(builder, monitorGridsOffset);
    OrgExport.addRoleBankPermissions(builder, roleBankPermissionsOffset);
    OrgExport.addRoleLiftPermissions(builder, roleLiftPermissionsOffset);
    OrgExport.addRoleFloorPermissions(builder, roleFloorPermissionsOffset);
    OrgExport.addTimedActions(builder, timedActionsOffset);
    OrgExport.addMessages(builder, messagesOffset);
    OrgExport.addMessageTypes(builder, messageTypesOffset);
    OrgExport.addRoleOrgGrants(builder, roleOrgGrantsOffset);
    OrgExport.addControlRoutes(builder, controlRoutesOffset);
    OrgExport.addControlRouteTargets(builder, controlRouteTargetsOffset);
    OrgExport.addNotificationBanks(builder, notificationBanksOffset);
    OrgExport.addWizardDrafts(builder, wizardDraftsOffset);
    return OrgExport.endOrgExport(builder);
  }

  unpack(): OrgExportT {
    return new OrgExportT(
      this.meta() !== null ? this.meta()!.unpack() : null,
      this.bb!.createObjList<Organization, OrganizationT>(
        this.organizations.bind(this),
        this.organizationsLength(),
      ),
      this.bb!.createObjList<Parameter, ParameterT>(
        this.parameters.bind(this),
        this.parametersLength(),
      ),
      this.bb!.createObjList<Holiday, HolidayT>(this.holidays.bind(this), this.holidaysLength()),
      this.bb!.createObjList<Server, ServerT>(this.servers.bind(this), this.serversLength()),
      this.bb!.createObjList<LeadingZeroes, LeadingZeroesT>(
        this.leadingZeroes.bind(this),
        this.leadingZeroesLength(),
      ),
      this.bb!.createObjList<Adapter, AdapterT>(this.adapters.bind(this), this.adaptersLength()),
      this.bb!.createObjList<Key, KeyT>(this.keys.bind(this), this.keysLength()),
      this.bb!.createObjList<CustomKey, CustomKeyT>(
        this.customKeys.bind(this),
        this.customKeysLength(),
      ),
      this.bb!.createObjList<Channel, ChannelT>(this.channels.bind(this), this.channelsLength()),
      this.bb!.createObjList<Bank, BankT>(this.banks.bind(this), this.banksLength()),
      this.bb!.createObjList<BankFloor, BankFloorT>(
        this.bankFloors.bind(this),
        this.bankFloorsLength(),
      ),
      this.bb!.createObjList<ChannelModifier, ChannelModifierT>(
        this.channelModifiers.bind(this),
        this.channelModifiersLength(),
      ),
      this.bb!.createObjList<Lift, LiftT>(this.lifts.bind(this), this.liftsLength()),
      this.bb!.createObjList<LiftFloor, LiftFloorT>(
        this.liftFloors.bind(this),
        this.liftFloorsLength(),
      ),
      this.bb!.createObjList<BacnetPoint, BacnetPointT>(
        this.bacnetPoints.bind(this),
        this.bacnetPointsLength(),
      ),
      this.bb!.createObjList<Role, RoleT>(this.roles.bind(this), this.rolesLength()),
      this.bb!.createObjList<User, UserT>(this.users.bind(this), this.usersLength()),
      this.bb!.createObjList<ContactInfo, ContactInfoT>(
        this.contactInfos.bind(this),
        this.contactInfosLength(),
      ),
      this.bb!.createObjList<Notification, NotificationT>(
        this.notifications.bind(this),
        this.notificationsLength(),
      ),
      this.bb!.createObjList<NotificationUser, NotificationUserT>(
        this.notificationUsers.bind(this),
        this.notificationUsersLength(),
      ),
      this.bb!.createObjList<DebounceOverride, DebounceOverrideT>(
        this.debounceOverrides.bind(this),
        this.debounceOverridesLength(),
      ),
      this.bb!.createObjList<ActionCatalog, ActionCatalogT>(
        this.actionCatalogs.bind(this),
        this.actionCatalogsLength(),
      ),
      this.bb!.createObjList<ActionCatalogAdapter, ActionCatalogAdapterT>(
        this.actionCatalogAdapters.bind(this),
        this.actionCatalogAdaptersLength(),
      ),
      this.bb!.createObjList<ActionBank, ActionBankT>(
        this.actionBanks.bind(this),
        this.actionBanksLength(),
      ),
      this.bb!.createObjList<MonitorGrid, MonitorGridT>(
        this.monitorGrids.bind(this),
        this.monitorGridsLength(),
      ),
      this.bb!.createObjList<RoleBankPermission, RoleBankPermissionT>(
        this.roleBankPermissions.bind(this),
        this.roleBankPermissionsLength(),
      ),
      this.bb!.createObjList<RoleLiftPermission, RoleLiftPermissionT>(
        this.roleLiftPermissions.bind(this),
        this.roleLiftPermissionsLength(),
      ),
      this.bb!.createObjList<RoleFloorPermission, RoleFloorPermissionT>(
        this.roleFloorPermissions.bind(this),
        this.roleFloorPermissionsLength(),
      ),
      this.bb!.createObjList<TimedAction, TimedActionT>(
        this.timedActions.bind(this),
        this.timedActionsLength(),
      ),
      this.bb!.createObjList<Message, MessageT>(this.messages.bind(this), this.messagesLength()),
      this.bb!.createObjList<MessageType, MessageTypeT>(
        this.messageTypes.bind(this),
        this.messageTypesLength(),
      ),
      this.bb!.createObjList<RoleOrgGrant, RoleOrgGrantT>(
        this.roleOrgGrants.bind(this),
        this.roleOrgGrantsLength(),
      ),
      this.bb!.createObjList<ControlRoute, ControlRouteT>(
        this.controlRoutes.bind(this),
        this.controlRoutesLength(),
      ),
      this.bb!.createObjList<ControlRouteTarget, ControlRouteTargetT>(
        this.controlRouteTargets.bind(this),
        this.controlRouteTargetsLength(),
      ),
      this.bb!.createObjList<NotificationBank, NotificationBankT>(
        this.notificationBanks.bind(this),
        this.notificationBanksLength(),
      ),
      this.bb!.createObjList<WizardDraft, WizardDraftT>(
        this.wizardDrafts.bind(this),
        this.wizardDraftsLength(),
      ),
    );
  }

  unpackTo(_o: OrgExportT): void {
    _o.meta = this.meta() !== null ? this.meta()!.unpack() : null;
    _o.organizations = this.bb!.createObjList<Organization, OrganizationT>(
      this.organizations.bind(this),
      this.organizationsLength(),
    );
    _o.parameters = this.bb!.createObjList<Parameter, ParameterT>(
      this.parameters.bind(this),
      this.parametersLength(),
    );
    _o.holidays = this.bb!.createObjList<Holiday, HolidayT>(
      this.holidays.bind(this),
      this.holidaysLength(),
    );
    _o.servers = this.bb!.createObjList<Server, ServerT>(
      this.servers.bind(this),
      this.serversLength(),
    );
    _o.leadingZeroes = this.bb!.createObjList<LeadingZeroes, LeadingZeroesT>(
      this.leadingZeroes.bind(this),
      this.leadingZeroesLength(),
    );
    _o.adapters = this.bb!.createObjList<Adapter, AdapterT>(
      this.adapters.bind(this),
      this.adaptersLength(),
    );
    _o.keys = this.bb!.createObjList<Key, KeyT>(this.keys.bind(this), this.keysLength());
    _o.customKeys = this.bb!.createObjList<CustomKey, CustomKeyT>(
      this.customKeys.bind(this),
      this.customKeysLength(),
    );
    _o.channels = this.bb!.createObjList<Channel, ChannelT>(
      this.channels.bind(this),
      this.channelsLength(),
    );
    _o.banks = this.bb!.createObjList<Bank, BankT>(this.banks.bind(this), this.banksLength());
    _o.bankFloors = this.bb!.createObjList<BankFloor, BankFloorT>(
      this.bankFloors.bind(this),
      this.bankFloorsLength(),
    );
    _o.channelModifiers = this.bb!.createObjList<ChannelModifier, ChannelModifierT>(
      this.channelModifiers.bind(this),
      this.channelModifiersLength(),
    );
    _o.lifts = this.bb!.createObjList<Lift, LiftT>(this.lifts.bind(this), this.liftsLength());
    _o.liftFloors = this.bb!.createObjList<LiftFloor, LiftFloorT>(
      this.liftFloors.bind(this),
      this.liftFloorsLength(),
    );
    _o.bacnetPoints = this.bb!.createObjList<BacnetPoint, BacnetPointT>(
      this.bacnetPoints.bind(this),
      this.bacnetPointsLength(),
    );
    _o.roles = this.bb!.createObjList<Role, RoleT>(this.roles.bind(this), this.rolesLength());
    _o.users = this.bb!.createObjList<User, UserT>(this.users.bind(this), this.usersLength());
    _o.contactInfos = this.bb!.createObjList<ContactInfo, ContactInfoT>(
      this.contactInfos.bind(this),
      this.contactInfosLength(),
    );
    _o.notifications = this.bb!.createObjList<Notification, NotificationT>(
      this.notifications.bind(this),
      this.notificationsLength(),
    );
    _o.notificationUsers = this.bb!.createObjList<NotificationUser, NotificationUserT>(
      this.notificationUsers.bind(this),
      this.notificationUsersLength(),
    );
    _o.debounceOverrides = this.bb!.createObjList<DebounceOverride, DebounceOverrideT>(
      this.debounceOverrides.bind(this),
      this.debounceOverridesLength(),
    );
    _o.actionCatalogs = this.bb!.createObjList<ActionCatalog, ActionCatalogT>(
      this.actionCatalogs.bind(this),
      this.actionCatalogsLength(),
    );
    _o.actionCatalogAdapters = this.bb!.createObjList<ActionCatalogAdapter, ActionCatalogAdapterT>(
      this.actionCatalogAdapters.bind(this),
      this.actionCatalogAdaptersLength(),
    );
    _o.actionBanks = this.bb!.createObjList<ActionBank, ActionBankT>(
      this.actionBanks.bind(this),
      this.actionBanksLength(),
    );
    _o.monitorGrids = this.bb!.createObjList<MonitorGrid, MonitorGridT>(
      this.monitorGrids.bind(this),
      this.monitorGridsLength(),
    );
    _o.roleBankPermissions = this.bb!.createObjList<RoleBankPermission, RoleBankPermissionT>(
      this.roleBankPermissions.bind(this),
      this.roleBankPermissionsLength(),
    );
    _o.roleLiftPermissions = this.bb!.createObjList<RoleLiftPermission, RoleLiftPermissionT>(
      this.roleLiftPermissions.bind(this),
      this.roleLiftPermissionsLength(),
    );
    _o.roleFloorPermissions = this.bb!.createObjList<RoleFloorPermission, RoleFloorPermissionT>(
      this.roleFloorPermissions.bind(this),
      this.roleFloorPermissionsLength(),
    );
    _o.timedActions = this.bb!.createObjList<TimedAction, TimedActionT>(
      this.timedActions.bind(this),
      this.timedActionsLength(),
    );
    _o.messages = this.bb!.createObjList<Message, MessageT>(
      this.messages.bind(this),
      this.messagesLength(),
    );
    _o.messageTypes = this.bb!.createObjList<MessageType, MessageTypeT>(
      this.messageTypes.bind(this),
      this.messageTypesLength(),
    );
    _o.roleOrgGrants = this.bb!.createObjList<RoleOrgGrant, RoleOrgGrantT>(
      this.roleOrgGrants.bind(this),
      this.roleOrgGrantsLength(),
    );
    _o.controlRoutes = this.bb!.createObjList<ControlRoute, ControlRouteT>(
      this.controlRoutes.bind(this),
      this.controlRoutesLength(),
    );
    _o.controlRouteTargets = this.bb!.createObjList<ControlRouteTarget, ControlRouteTargetT>(
      this.controlRouteTargets.bind(this),
      this.controlRouteTargetsLength(),
    );
    _o.notificationBanks = this.bb!.createObjList<NotificationBank, NotificationBankT>(
      this.notificationBanks.bind(this),
      this.notificationBanksLength(),
    );
    _o.wizardDrafts = this.bb!.createObjList<WizardDraft, WizardDraftT>(
      this.wizardDrafts.bind(this),
      this.wizardDraftsLength(),
    );
  }

  unpackFields(...fields: string[]): OrgExportT {
    const t = new OrgExportT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("meta")) {
      t.meta = this.meta() !== null ? this.meta()!.unpack() : null;
    }
    if (fieldSet.has("organizations")) {
      t.organizations = this.bb!.createObjList<Organization, OrganizationT>(
        this.organizations.bind(this),
        this.organizationsLength(),
      );
    }
    if (fieldSet.has("parameters")) {
      t.parameters = this.bb!.createObjList<Parameter, ParameterT>(
        this.parameters.bind(this),
        this.parametersLength(),
      );
    }
    if (fieldSet.has("holidays")) {
      t.holidays = this.bb!.createObjList<Holiday, HolidayT>(
        this.holidays.bind(this),
        this.holidaysLength(),
      );
    }
    if (fieldSet.has("servers")) {
      t.servers = this.bb!.createObjList<Server, ServerT>(
        this.servers.bind(this),
        this.serversLength(),
      );
    }
    if (fieldSet.has("leading_zeroes")) {
      t.leadingZeroes = this.bb!.createObjList<LeadingZeroes, LeadingZeroesT>(
        this.leadingZeroes.bind(this),
        this.leadingZeroesLength(),
      );
    }
    if (fieldSet.has("adapters")) {
      t.adapters = this.bb!.createObjList<Adapter, AdapterT>(
        this.adapters.bind(this),
        this.adaptersLength(),
      );
    }
    if (fieldSet.has("keys")) {
      t.keys = this.bb!.createObjList<Key, KeyT>(this.keys.bind(this), this.keysLength());
    }
    if (fieldSet.has("custom_keys")) {
      t.customKeys = this.bb!.createObjList<CustomKey, CustomKeyT>(
        this.customKeys.bind(this),
        this.customKeysLength(),
      );
    }
    if (fieldSet.has("channels")) {
      t.channels = this.bb!.createObjList<Channel, ChannelT>(
        this.channels.bind(this),
        this.channelsLength(),
      );
    }
    if (fieldSet.has("banks")) {
      t.banks = this.bb!.createObjList<Bank, BankT>(this.banks.bind(this), this.banksLength());
    }
    if (fieldSet.has("bank_floors")) {
      t.bankFloors = this.bb!.createObjList<BankFloor, BankFloorT>(
        this.bankFloors.bind(this),
        this.bankFloorsLength(),
      );
    }
    if (fieldSet.has("channel_modifiers")) {
      t.channelModifiers = this.bb!.createObjList<ChannelModifier, ChannelModifierT>(
        this.channelModifiers.bind(this),
        this.channelModifiersLength(),
      );
    }
    if (fieldSet.has("lifts")) {
      t.lifts = this.bb!.createObjList<Lift, LiftT>(this.lifts.bind(this), this.liftsLength());
    }
    if (fieldSet.has("lift_floors")) {
      t.liftFloors = this.bb!.createObjList<LiftFloor, LiftFloorT>(
        this.liftFloors.bind(this),
        this.liftFloorsLength(),
      );
    }
    if (fieldSet.has("bacnet_points")) {
      t.bacnetPoints = this.bb!.createObjList<BacnetPoint, BacnetPointT>(
        this.bacnetPoints.bind(this),
        this.bacnetPointsLength(),
      );
    }
    if (fieldSet.has("roles")) {
      t.roles = this.bb!.createObjList<Role, RoleT>(this.roles.bind(this), this.rolesLength());
    }
    if (fieldSet.has("users")) {
      t.users = this.bb!.createObjList<User, UserT>(this.users.bind(this), this.usersLength());
    }
    if (fieldSet.has("contact_infos")) {
      t.contactInfos = this.bb!.createObjList<ContactInfo, ContactInfoT>(
        this.contactInfos.bind(this),
        this.contactInfosLength(),
      );
    }
    if (fieldSet.has("notifications")) {
      t.notifications = this.bb!.createObjList<Notification, NotificationT>(
        this.notifications.bind(this),
        this.notificationsLength(),
      );
    }
    if (fieldSet.has("notification_users")) {
      t.notificationUsers = this.bb!.createObjList<NotificationUser, NotificationUserT>(
        this.notificationUsers.bind(this),
        this.notificationUsersLength(),
      );
    }
    if (fieldSet.has("debounce_overrides")) {
      t.debounceOverrides = this.bb!.createObjList<DebounceOverride, DebounceOverrideT>(
        this.debounceOverrides.bind(this),
        this.debounceOverridesLength(),
      );
    }
    if (fieldSet.has("action_catalogs")) {
      t.actionCatalogs = this.bb!.createObjList<ActionCatalog, ActionCatalogT>(
        this.actionCatalogs.bind(this),
        this.actionCatalogsLength(),
      );
    }
    if (fieldSet.has("action_catalog_adapters")) {
      t.actionCatalogAdapters = this.bb!.createObjList<ActionCatalogAdapter, ActionCatalogAdapterT>(
        this.actionCatalogAdapters.bind(this),
        this.actionCatalogAdaptersLength(),
      );
    }
    if (fieldSet.has("action_banks")) {
      t.actionBanks = this.bb!.createObjList<ActionBank, ActionBankT>(
        this.actionBanks.bind(this),
        this.actionBanksLength(),
      );
    }
    if (fieldSet.has("monitor_grids")) {
      t.monitorGrids = this.bb!.createObjList<MonitorGrid, MonitorGridT>(
        this.monitorGrids.bind(this),
        this.monitorGridsLength(),
      );
    }
    if (fieldSet.has("role_bank_permissions")) {
      t.roleBankPermissions = this.bb!.createObjList<RoleBankPermission, RoleBankPermissionT>(
        this.roleBankPermissions.bind(this),
        this.roleBankPermissionsLength(),
      );
    }
    if (fieldSet.has("role_lift_permissions")) {
      t.roleLiftPermissions = this.bb!.createObjList<RoleLiftPermission, RoleLiftPermissionT>(
        this.roleLiftPermissions.bind(this),
        this.roleLiftPermissionsLength(),
      );
    }
    if (fieldSet.has("role_floor_permissions")) {
      t.roleFloorPermissions = this.bb!.createObjList<RoleFloorPermission, RoleFloorPermissionT>(
        this.roleFloorPermissions.bind(this),
        this.roleFloorPermissionsLength(),
      );
    }
    if (fieldSet.has("timed_actions")) {
      t.timedActions = this.bb!.createObjList<TimedAction, TimedActionT>(
        this.timedActions.bind(this),
        this.timedActionsLength(),
      );
    }
    if (fieldSet.has("messages")) {
      t.messages = this.bb!.createObjList<Message, MessageT>(
        this.messages.bind(this),
        this.messagesLength(),
      );
    }
    if (fieldSet.has("message_types")) {
      t.messageTypes = this.bb!.createObjList<MessageType, MessageTypeT>(
        this.messageTypes.bind(this),
        this.messageTypesLength(),
      );
    }
    if (fieldSet.has("role_org_grants")) {
      t.roleOrgGrants = this.bb!.createObjList<RoleOrgGrant, RoleOrgGrantT>(
        this.roleOrgGrants.bind(this),
        this.roleOrgGrantsLength(),
      );
    }
    if (fieldSet.has("control_routes")) {
      t.controlRoutes = this.bb!.createObjList<ControlRoute, ControlRouteT>(
        this.controlRoutes.bind(this),
        this.controlRoutesLength(),
      );
    }
    if (fieldSet.has("control_route_targets")) {
      t.controlRouteTargets = this.bb!.createObjList<ControlRouteTarget, ControlRouteTargetT>(
        this.controlRouteTargets.bind(this),
        this.controlRouteTargetsLength(),
      );
    }
    if (fieldSet.has("notification_banks")) {
      t.notificationBanks = this.bb!.createObjList<NotificationBank, NotificationBankT>(
        this.notificationBanks.bind(this),
        this.notificationBanksLength(),
      );
    }
    if (fieldSet.has("wizard_drafts")) {
      t.wizardDrafts = this.bb!.createObjList<WizardDraft, WizardDraftT>(
        this.wizardDrafts.bind(this),
        this.wizardDraftsLength(),
      );
    }
    return t;
  }
}

export class OrgExportT implements flatbuffers.IGeneratedObject {
  constructor(
    public meta: ExportMetaT | null = null,
    public organizations: OrganizationT[] = [],
    public parameters: ParameterT[] = [],
    public holidays: HolidayT[] = [],
    public servers: ServerT[] = [],
    public leadingZeroes: LeadingZeroesT[] = [],
    public adapters: AdapterT[] = [],
    public keys: KeyT[] = [],
    public customKeys: CustomKeyT[] = [],
    public channels: ChannelT[] = [],
    public banks: BankT[] = [],
    public bankFloors: BankFloorT[] = [],
    public channelModifiers: ChannelModifierT[] = [],
    public lifts: LiftT[] = [],
    public liftFloors: LiftFloorT[] = [],
    public bacnetPoints: BacnetPointT[] = [],
    public roles: RoleT[] = [],
    public users: UserT[] = [],
    public contactInfos: ContactInfoT[] = [],
    public notifications: NotificationT[] = [],
    public notificationUsers: NotificationUserT[] = [],
    public debounceOverrides: DebounceOverrideT[] = [],
    public actionCatalogs: ActionCatalogT[] = [],
    public actionCatalogAdapters: ActionCatalogAdapterT[] = [],
    public actionBanks: ActionBankT[] = [],
    public monitorGrids: MonitorGridT[] = [],
    public roleBankPermissions: RoleBankPermissionT[] = [],
    public roleLiftPermissions: RoleLiftPermissionT[] = [],
    public roleFloorPermissions: RoleFloorPermissionT[] = [],
    public timedActions: TimedActionT[] = [],
    public messages: MessageT[] = [],
    public messageTypes: MessageTypeT[] = [],
    public roleOrgGrants: RoleOrgGrantT[] = [],
    public controlRoutes: ControlRouteT[] = [],
    public controlRouteTargets: ControlRouteTargetT[] = [],
    public notificationBanks: NotificationBankT[] = [],
    public wizardDrafts: WizardDraftT[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.meta === null || this.meta === undefined) {
      throw new Error('Required field "meta" is not set');
    }
    const meta = this.meta !== null ? this.meta!.pack(builder) : 0;
    const organizations = OrgExport.createOrganizationsVector(
      builder,
      builder.createObjectOffsetList(this.organizations),
    );
    const parameters = OrgExport.createParametersVector(
      builder,
      builder.createObjectOffsetList(this.parameters),
    );
    const holidays = OrgExport.createHolidaysVector(
      builder,
      builder.createObjectOffsetList(this.holidays),
    );
    const servers = OrgExport.createServersVector(
      builder,
      builder.createObjectOffsetList(this.servers),
    );
    const leadingZeroes = OrgExport.createLeadingZeroesVector(
      builder,
      builder.createObjectOffsetList(this.leadingZeroes),
    );
    const adapters = OrgExport.createAdaptersVector(
      builder,
      builder.createObjectOffsetList(this.adapters),
    );
    const keys = OrgExport.createKeysVector(builder, builder.createObjectOffsetList(this.keys));
    const customKeys = OrgExport.createCustomKeysVector(
      builder,
      builder.createObjectOffsetList(this.customKeys),
    );
    const channels = OrgExport.createChannelsVector(
      builder,
      builder.createObjectOffsetList(this.channels),
    );
    const banks = OrgExport.createBanksVector(builder, builder.createObjectOffsetList(this.banks));
    const bankFloors = OrgExport.createBankFloorsVector(
      builder,
      builder.createObjectOffsetList(this.bankFloors),
    );
    const channelModifiers = OrgExport.createChannelModifiersVector(
      builder,
      builder.createObjectOffsetList(this.channelModifiers),
    );
    const lifts = OrgExport.createLiftsVector(builder, builder.createObjectOffsetList(this.lifts));
    const liftFloors = OrgExport.createLiftFloorsVector(
      builder,
      builder.createObjectOffsetList(this.liftFloors),
    );
    const bacnetPoints = OrgExport.createBacnetPointsVector(
      builder,
      builder.createObjectOffsetList(this.bacnetPoints),
    );
    const roles = OrgExport.createRolesVector(builder, builder.createObjectOffsetList(this.roles));
    const users = OrgExport.createUsersVector(builder, builder.createObjectOffsetList(this.users));
    const contactInfos = OrgExport.createContactInfosVector(
      builder,
      builder.createObjectOffsetList(this.contactInfos),
    );
    const notifications = OrgExport.createNotificationsVector(
      builder,
      builder.createObjectOffsetList(this.notifications),
    );
    const notificationUsers = OrgExport.createNotificationUsersVector(
      builder,
      builder.createObjectOffsetList(this.notificationUsers),
    );
    const debounceOverrides = OrgExport.createDebounceOverridesVector(
      builder,
      builder.createObjectOffsetList(this.debounceOverrides),
    );
    const actionCatalogs = OrgExport.createActionCatalogsVector(
      builder,
      builder.createObjectOffsetList(this.actionCatalogs),
    );
    const actionCatalogAdapters = OrgExport.createActionCatalogAdaptersVector(
      builder,
      builder.createObjectOffsetList(this.actionCatalogAdapters),
    );
    const actionBanks = OrgExport.createActionBanksVector(
      builder,
      builder.createObjectOffsetList(this.actionBanks),
    );
    const monitorGrids = OrgExport.createMonitorGridsVector(
      builder,
      builder.createObjectOffsetList(this.monitorGrids),
    );
    const roleBankPermissions = OrgExport.createRoleBankPermissionsVector(
      builder,
      builder.createObjectOffsetList(this.roleBankPermissions),
    );
    const roleLiftPermissions = OrgExport.createRoleLiftPermissionsVector(
      builder,
      builder.createObjectOffsetList(this.roleLiftPermissions),
    );
    const roleFloorPermissions = OrgExport.createRoleFloorPermissionsVector(
      builder,
      builder.createObjectOffsetList(this.roleFloorPermissions),
    );
    const timedActions = OrgExport.createTimedActionsVector(
      builder,
      builder.createObjectOffsetList(this.timedActions),
    );
    const messages = OrgExport.createMessagesVector(
      builder,
      builder.createObjectOffsetList(this.messages),
    );
    const messageTypes = OrgExport.createMessageTypesVector(
      builder,
      builder.createObjectOffsetList(this.messageTypes),
    );
    const roleOrgGrants = OrgExport.createRoleOrgGrantsVector(
      builder,
      builder.createObjectOffsetList(this.roleOrgGrants),
    );
    const controlRoutes = OrgExport.createControlRoutesVector(
      builder,
      builder.createObjectOffsetList(this.controlRoutes),
    );
    const controlRouteTargets = OrgExport.createControlRouteTargetsVector(
      builder,
      builder.createObjectOffsetList(this.controlRouteTargets),
    );
    const notificationBanks = OrgExport.createNotificationBanksVector(
      builder,
      builder.createObjectOffsetList(this.notificationBanks),
    );
    const wizardDrafts = OrgExport.createWizardDraftsVector(
      builder,
      builder.createObjectOffsetList(this.wizardDrafts),
    );

    return OrgExport.createOrgExport(
      builder,
      meta,
      organizations,
      parameters,
      holidays,
      servers,
      leadingZeroes,
      adapters,
      keys,
      customKeys,
      channels,
      banks,
      bankFloors,
      channelModifiers,
      lifts,
      liftFloors,
      bacnetPoints,
      roles,
      users,
      contactInfos,
      notifications,
      notificationUsers,
      debounceOverrides,
      actionCatalogs,
      actionCatalogAdapters,
      actionBanks,
      monitorGrids,
      roleBankPermissions,
      roleLiftPermissions,
      roleFloorPermissions,
      timedActions,
      messages,
      messageTypes,
      roleOrgGrants,
      controlRoutes,
      controlRouteTargets,
      notificationBanks,
      wizardDrafts,
    );
  }

  clone(): OrgExportT {
    const obj = new OrgExportT();
    obj.meta = this.meta !== null ? this.meta!.clone() : null;
    obj.organizations = this.organizations.map((e) => e.clone());
    obj.parameters = this.parameters.map((e) => e.clone());
    obj.holidays = this.holidays.map((e) => e.clone());
    obj.servers = this.servers.map((e) => e.clone());
    obj.leadingZeroes = this.leadingZeroes.map((e) => e.clone());
    obj.adapters = this.adapters.map((e) => e.clone());
    obj.keys = this.keys.map((e) => e.clone());
    obj.customKeys = this.customKeys.map((e) => e.clone());
    obj.channels = this.channels.map((e) => e.clone());
    obj.banks = this.banks.map((e) => e.clone());
    obj.bankFloors = this.bankFloors.map((e) => e.clone());
    obj.channelModifiers = this.channelModifiers.map((e) => e.clone());
    obj.lifts = this.lifts.map((e) => e.clone());
    obj.liftFloors = this.liftFloors.map((e) => e.clone());
    obj.bacnetPoints = this.bacnetPoints.map((e) => e.clone());
    obj.roles = this.roles.map((e) => e.clone());
    obj.users = this.users.map((e) => e.clone());
    obj.contactInfos = this.contactInfos.map((e) => e.clone());
    obj.notifications = this.notifications.map((e) => e.clone());
    obj.notificationUsers = this.notificationUsers.map((e) => e.clone());
    obj.debounceOverrides = this.debounceOverrides.map((e) => e.clone());
    obj.actionCatalogs = this.actionCatalogs.map((e) => e.clone());
    obj.actionCatalogAdapters = this.actionCatalogAdapters.map((e) => e.clone());
    obj.actionBanks = this.actionBanks.map((e) => e.clone());
    obj.monitorGrids = this.monitorGrids.map((e) => e.clone());
    obj.roleBankPermissions = this.roleBankPermissions.map((e) => e.clone());
    obj.roleLiftPermissions = this.roleLiftPermissions.map((e) => e.clone());
    obj.roleFloorPermissions = this.roleFloorPermissions.map((e) => e.clone());
    obj.timedActions = this.timedActions.map((e) => e.clone());
    obj.messages = this.messages.map((e) => e.clone());
    obj.messageTypes = this.messageTypes.map((e) => e.clone());
    obj.roleOrgGrants = this.roleOrgGrants.map((e) => e.clone());
    obj.controlRoutes = this.controlRoutes.map((e) => e.clone());
    obj.controlRouteTargets = this.controlRouteTargets.map((e) => e.clone());
    obj.notificationBanks = this.notificationBanks.map((e) => e.clone());
    obj.wizardDrafts = this.wizardDrafts.map((e) => e.clone());
    return obj;
  }

  equals(other: OrgExportT): boolean {
    if (this.meta !== null && other.meta !== null) {
      if (!this.meta!.equals(other.meta!)) return false;
    } else if (this.meta !== other.meta) return false;
    if (this.organizations.length !== other.organizations.length) return false;
    for (let i = 0; i < this.organizations.length; i++) {
      const a = this.organizations[i];
      const b = other.organizations[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.parameters.length !== other.parameters.length) return false;
    for (let i = 0; i < this.parameters.length; i++) {
      const a = this.parameters[i];
      const b = other.parameters[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.holidays.length !== other.holidays.length) return false;
    for (let i = 0; i < this.holidays.length; i++) {
      const a = this.holidays[i];
      const b = other.holidays[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.servers.length !== other.servers.length) return false;
    for (let i = 0; i < this.servers.length; i++) {
      const a = this.servers[i];
      const b = other.servers[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.leadingZeroes.length !== other.leadingZeroes.length) return false;
    for (let i = 0; i < this.leadingZeroes.length; i++) {
      const a = this.leadingZeroes[i];
      const b = other.leadingZeroes[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.adapters.length !== other.adapters.length) return false;
    for (let i = 0; i < this.adapters.length; i++) {
      const a = this.adapters[i];
      const b = other.adapters[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.keys.length !== other.keys.length) return false;
    for (let i = 0; i < this.keys.length; i++) {
      const a = this.keys[i];
      const b = other.keys[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.customKeys.length !== other.customKeys.length) return false;
    for (let i = 0; i < this.customKeys.length; i++) {
      const a = this.customKeys[i];
      const b = other.customKeys[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.channels.length !== other.channels.length) return false;
    for (let i = 0; i < this.channels.length; i++) {
      const a = this.channels[i];
      const b = other.channels[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.banks.length !== other.banks.length) return false;
    for (let i = 0; i < this.banks.length; i++) {
      const a = this.banks[i];
      const b = other.banks[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.bankFloors.length !== other.bankFloors.length) return false;
    for (let i = 0; i < this.bankFloors.length; i++) {
      const a = this.bankFloors[i];
      const b = other.bankFloors[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.channelModifiers.length !== other.channelModifiers.length) return false;
    for (let i = 0; i < this.channelModifiers.length; i++) {
      const a = this.channelModifiers[i];
      const b = other.channelModifiers[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.lifts.length !== other.lifts.length) return false;
    for (let i = 0; i < this.lifts.length; i++) {
      const a = this.lifts[i];
      const b = other.lifts[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.liftFloors.length !== other.liftFloors.length) return false;
    for (let i = 0; i < this.liftFloors.length; i++) {
      const a = this.liftFloors[i];
      const b = other.liftFloors[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.bacnetPoints.length !== other.bacnetPoints.length) return false;
    for (let i = 0; i < this.bacnetPoints.length; i++) {
      const a = this.bacnetPoints[i];
      const b = other.bacnetPoints[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.roles.length !== other.roles.length) return false;
    for (let i = 0; i < this.roles.length; i++) {
      const a = this.roles[i];
      const b = other.roles[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.users.length !== other.users.length) return false;
    for (let i = 0; i < this.users.length; i++) {
      const a = this.users[i];
      const b = other.users[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.contactInfos.length !== other.contactInfos.length) return false;
    for (let i = 0; i < this.contactInfos.length; i++) {
      const a = this.contactInfos[i];
      const b = other.contactInfos[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.notifications.length !== other.notifications.length) return false;
    for (let i = 0; i < this.notifications.length; i++) {
      const a = this.notifications[i];
      const b = other.notifications[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.notificationUsers.length !== other.notificationUsers.length) return false;
    for (let i = 0; i < this.notificationUsers.length; i++) {
      const a = this.notificationUsers[i];
      const b = other.notificationUsers[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.debounceOverrides.length !== other.debounceOverrides.length) return false;
    for (let i = 0; i < this.debounceOverrides.length; i++) {
      const a = this.debounceOverrides[i];
      const b = other.debounceOverrides[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.actionCatalogs.length !== other.actionCatalogs.length) return false;
    for (let i = 0; i < this.actionCatalogs.length; i++) {
      const a = this.actionCatalogs[i];
      const b = other.actionCatalogs[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.actionCatalogAdapters.length !== other.actionCatalogAdapters.length) return false;
    for (let i = 0; i < this.actionCatalogAdapters.length; i++) {
      const a = this.actionCatalogAdapters[i];
      const b = other.actionCatalogAdapters[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.actionBanks.length !== other.actionBanks.length) return false;
    for (let i = 0; i < this.actionBanks.length; i++) {
      const a = this.actionBanks[i];
      const b = other.actionBanks[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.monitorGrids.length !== other.monitorGrids.length) return false;
    for (let i = 0; i < this.monitorGrids.length; i++) {
      const a = this.monitorGrids[i];
      const b = other.monitorGrids[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.roleBankPermissions.length !== other.roleBankPermissions.length) return false;
    for (let i = 0; i < this.roleBankPermissions.length; i++) {
      const a = this.roleBankPermissions[i];
      const b = other.roleBankPermissions[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.roleLiftPermissions.length !== other.roleLiftPermissions.length) return false;
    for (let i = 0; i < this.roleLiftPermissions.length; i++) {
      const a = this.roleLiftPermissions[i];
      const b = other.roleLiftPermissions[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.roleFloorPermissions.length !== other.roleFloorPermissions.length) return false;
    for (let i = 0; i < this.roleFloorPermissions.length; i++) {
      const a = this.roleFloorPermissions[i];
      const b = other.roleFloorPermissions[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.timedActions.length !== other.timedActions.length) return false;
    for (let i = 0; i < this.timedActions.length; i++) {
      const a = this.timedActions[i];
      const b = other.timedActions[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.messages.length !== other.messages.length) return false;
    for (let i = 0; i < this.messages.length; i++) {
      const a = this.messages[i];
      const b = other.messages[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.messageTypes.length !== other.messageTypes.length) return false;
    for (let i = 0; i < this.messageTypes.length; i++) {
      const a = this.messageTypes[i];
      const b = other.messageTypes[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.roleOrgGrants.length !== other.roleOrgGrants.length) return false;
    for (let i = 0; i < this.roleOrgGrants.length; i++) {
      const a = this.roleOrgGrants[i];
      const b = other.roleOrgGrants[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.controlRoutes.length !== other.controlRoutes.length) return false;
    for (let i = 0; i < this.controlRoutes.length; i++) {
      const a = this.controlRoutes[i];
      const b = other.controlRoutes[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.controlRouteTargets.length !== other.controlRouteTargets.length) return false;
    for (let i = 0; i < this.controlRouteTargets.length; i++) {
      const a = this.controlRouteTargets[i];
      const b = other.controlRouteTargets[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.notificationBanks.length !== other.notificationBanks.length) return false;
    for (let i = 0; i < this.notificationBanks.length; i++) {
      const a = this.notificationBanks[i];
      const b = other.notificationBanks[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.wizardDrafts.length !== other.wizardDrafts.length) return false;
    for (let i = 0; i < this.wizardDrafts.length; i++) {
      const a = this.wizardDrafts[i];
      const b = other.wizardDrafts[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyOrgExport(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyExportMeta(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "meta");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyOrganization);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyParameter);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyHoliday);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyServer);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyLeadingZeroes);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyAdapter);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyKey);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyCustomKey);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyChannel);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 24);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyBank);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 26);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyBankFloor);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 28);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyChannelModifier);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 30);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyLift);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 32);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyLiftFloor);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 34);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyBacnetPoint);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 36);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyRole);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 38);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyUser);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 40);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyContactInfo);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 42);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyNotification);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 44);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyNotificationUser);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 46);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyDebounceOverride);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 48);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyActionCatalog);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 50);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyActionCatalogAdapter);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 52);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyActionBank);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 54);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyMonitorGrid);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 56);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyRoleBankPermission);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 58);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyRoleLiftPermission);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 60);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyRoleFloorPermission);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 62);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyTimedAction);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 64);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyMessage);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 66);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyMessageType);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 68);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyRoleOrgGrant);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 70);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyControlRoute);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 72);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyControlRouteTarget);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 74);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyNotificationBank);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 76);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyWizardDraft);
      }
    }
  } finally {
    verifier.popDepth();
  }
}

export function verifyRootAsOrgExport(buf: DataView, opts?: flatbuffers.VerifierOptions): void {
  const verifier = new flatbuffers.Verifier(buf, opts);
  const tablePos = verifier.readUint32(0);
  verifyOrgExport(verifier, tablePos);
}
